import countriesJSON from '../json/countries.json'

export function formatNationality(country_code) {
    if (typeof country_code === 'string') {
        const { name } = countriesJSON.find(({ code }) => code === country_code)
        return name
    }
    return ""
}